// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.0.10";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://a34598051a5a13075a2ad186b79bb810@o553113.ingest.us.sentry.io/4508637282566144",

  // CRITICAL: Set the release to match uploaded source maps
  release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 0.1,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  enabled: process.env.NODE_ENV === "production",

  // Filter out intentional user-triggered events that aren't actual errors
  beforeSend(event, hint) {
    const error = hint.originalException;

    // Filter out route cancellation - this is intentional user behavior, not an error
    if (
      error &&
      typeof error === "object" &&
      "name" in error &&
      error.name === "RouteChangeCancelled"
    ) {
      return null;
    }

    // Filter out unauthorized ApiErrors - these are expected when user session expires
    if (
      error &&
      typeof error === "object" &&
      "name" in error &&
      error.name === "ApiError" &&
      "status" in error &&
      error.status === 401
    ) {
      return null;
    }

    // Also filter by message for backwards compatibility with old string throws
    if (
      event.exception?.values?.[0]?.value?.includes(
        "Route change cancelled by user"
      ) ||
      event.exception?.values?.[0]?.value?.includes("Route change aborted") ||
      event.exception?.values?.[0]?.value?.includes("Not authorized")
    ) {
      return null;
    }

    return event;
  },
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

